export default __webpack_public_path__ + "static/salem-b9db024649ef265a91c6f08195c3a44b.gif";